const flow =
    (...actions) =>
        value =>
            actions.reduce(
                (args, action) => action(args),
                value,
            );

/**
 * Rounds a float to 2 digits after a decimal point, "half-down".
 * @param {string|number} float - a string represetation of a float, or a float number
 * @returns {number} - a float rounded to 2 digits after a decimal point.
 */
const roundHalfDown = flow(
    parseFloat,
    // round "half-down": 2.2250 -> 2.22
    x => (x * 100) - 0.1,
    Math.round,
    x => x / 100,
);

export default roundHalfDown;



// WEBPACK FOOTER //
// /src/js/common/utils/roundHalfDown.js